module.exports = __webpack_public_path__ + "img/cert-audit.f0039909.svg";